import React, { Component } from 'react';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { tooltipShow } from '../../../../actions/tooltipActions';
import CheckIfAnyData from '../../../shared/CheckIfAnyData';
import Spinner from '../../../shared/_Spinner';
import MyOffersDesktop from './MyOffersDesktop';
import MyOffersMobile from './MyOffersMobile';
import OthersOffersDesktop from './OthersOffersDesktop';
import OthersOffersMobile from './OthersOffersMobile';
import { isMobile } from '../../../../lib/responsive';
import { fetchPostedOffers } from '../../../../actions/postedOffersActions';
import FrequencyLimitModal from './FrequencyLimitModal';

const FREQUENCY_MODAL_ID = 'frequencyModal';

class Offers extends Component {
  componentDidMount() {
    const { postedOffersFetch } = this.props;

    postedOffersFetch();
  }

  render() {
    return (
      <div className='trade-post'>
        {this._renderPostedTrades()}
        {this._renderRequestedTrades()}
      </div>

    );
  }

  _renderPostedTrades = () => {
    const { myOffers, loading } = this.props;
    const MyOffers = isMobile ? MyOffersMobile : MyOffersDesktop;

    return (
      <React.Fragment>
        <div className={ 'trade-post__title' }>Trades posted</div>
        { !isMobile && (
          <div className='trade-post__header'>
            <div className='trade-post__header-item trade-post__one-third'>Office</div>
            <div className='trade-post__header-item trade-post__one-third'>Offered Appt</div>
            <div className='trade-post__header-item trade-post__one-third'>Status</div>
          </div>
        )}
        <Spinner enabled={ loading }>
          <CheckIfAnyData dataSize={ myOffers.size } message={ 'There are no trade offers' }>
            <MyOffers myOffers={ myOffers } />
          </CheckIfAnyData>
        </Spinner>
      </React.Fragment>
    );
  };

  _renderRequestedTrades = () => {
    const { othersOffers, loading, showModal } = this.props;
    const OthersOffers = isMobile ? OthersOffersMobile : OthersOffersDesktop;

    return (
      <React.Fragment>
        <div className={ 'trade-post__title' }>Trades offered</div>
        { !isMobile && (
          <div className='trade-post__header'>
            <div className='trade-post__header-item trade-post__one-fourth'>Office</div>
            <div className='trade-post__header-item trade-post__one-fourth'>Offer Maker</div>
            <div className='trade-post__header-item trade-post__one-fourth'>Offered Appt</div>
            <div className='trade-post__header-item trade-post__one-fourth' />
          </div>
        )}
        <Spinner enabled={ loading }>
          <CheckIfAnyData dataSize={ othersOffers.size } message={ 'There are no trade offers' }>
            <OthersOffers openFrequencyModal={ this._onOpenFrequencyModal } othersOffers={ othersOffers } showModal={ showModal } />
          </CheckIfAnyData>
        </Spinner>
        <FrequencyLimitModal id={ FREQUENCY_MODAL_ID } />
      </React.Fragment>
    );
  };

  _onOpenFrequencyModal = () => {
    this.props.showModal(FREQUENCY_MODAL_ID);
  }
}

Offers.propTypes = {
  loading: PropTypes.bool,
  myOffers: PropTypes.instanceOf(Immutable.Map).isRequired,
  othersOffers: PropTypes.instanceOf(Immutable.Map).isRequired,
  postedOffersFetch: PropTypes.func.isRequired,
  showModal: PropTypes.func.isRequired
};

const mapStateToProps = (state) => ({
  myOffers: state.getIn(['postedOffers', 'data', 'myPostedOffers'], Immutable.Map()),
  othersOffers: state.getIn(['postedOffers', 'data', 'othersPostedOffers'], Immutable.Map()),
  loading: state.getIn(['postedOffers', 'loading'])
});

const mapDispatchToProps = (dispatch) => ({
  postedOffersFetch: (params) => dispatch(fetchPostedOffers(params)),
  showModal: (id) => dispatch(tooltipShow({ id }))
});

export default connect(mapStateToProps, mapDispatchToProps)(Offers);



// WEBPACK FOOTER //
// ./app/components/reps/trade_post/offers/Offers.jsx